import React, { useState, useEffect } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import NavbarComponent from "../layout/NavbarComponent";
import mainAdDefault from "../assets/images/advertisement.jpg";
import subAd1Default from "../assets/images/vet.jpg";
import subAd2Default from "../assets/images/pet-toys.jpg";
import subAd3Default from "../assets/images/pet-wash.jpg";
import subAd4Default from "../assets/images/grooming.jpg";
import Footer from "../layout/Footer";
import { Layout } from "../layout/Layout";
const API_URL = process.env.REACT_APP_API_URL;
const AdsComponent = () => {
  // Main ad state
  const [mainAd, setMainAd] = useState({
    src: mainAdDefault,
    link: "#",
  });

  const [subAds, setSubAds] = useState([
    { src: subAd1Default, title: "Vet Services", link: "#" },
    { src: subAd2Default, title: "Pet Toys", link: "#" },
    { src: subAd3Default, title: "Pet Wash", link: "#" },
    { src: subAd4Default, title: "Grooming", link: "#" },
  ]);

  const [showModal, setShowModal] = useState(false);
  const [currentEdit, setCurrentEdit] = useState({
    type: "",
    index: null,
    src: "",
    title: "",
    link: "",
  });

  // Added loading state while saving the ad.
  const [isSaving, setIsSaving] = useState(false);

  // Fetch from backend
  useEffect(() => {
    const fetchAds = async () => {
      try {
        const res = await fetch(`${API_URL}/getAds`);
        const data = await res.json();

        if (data.mainAdBase64) {
          setMainAd({
            src: `data:image/jpeg;base64,${data.mainAdBase64}`,
            link: data.mainAdLink || "#",
          });
        }

        const updatedSubs = [
          {
            src: data.subAd1Base64
              ? `data:image/jpeg;base64,${data.subAd1Base64}`
              : subAd1Default,
            title: "Vet Services",
            link: data.subAd1Link || "#",
          },
          {
            src: data.subAd2Base64
              ? `data:image/jpeg;base64,${data.subAd2Base64}`
              : subAd2Default,
            title: "Pet Toys",
            link: data.subAd2Link || "#",
          },
          {
            src: data.subAd3Base64
              ? `data:image/jpeg;base64,${data.subAd3Base64}`
              : subAd3Default,
            title: "Pet Wash",
            link: data.subAd3Link || "#",
          },
          {
            src: data.subAd4Base64
              ? `data:image/jpeg;base64,${data.subAd4Base64}`
              : subAd4Default,
            title: "Grooming",
            link: data.subAd4Link || "#",
          },
        ];

        setSubAds(updatedSubs);
      } catch (error) {
        console.error("Error fetching ads:", error);
      }
    };

    fetchAds();
  }, []);

  const handleEdit = (type, index = null, src = "", title = "", link = "#") => {
    setCurrentEdit({ type, index, src, title, link });
    setShowModal(true);
  };

  const handleImageSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setCurrentEdit({ ...currentEdit, src: reader.result });
      };
      reader.readAsDataURL(file);
    }
  };

  // Save image + link
  const handleSave = async () => {
    // Added validation to require both image and link before saving.
    if (!currentEdit.src || currentEdit.src.trim() === "") {
      alert("Please select an image!");
      return;
    }

    if (!currentEdit.link || currentEdit.link.trim() === "") {
      alert("Please enter ad link!");
      return;
    }

    // Added loading state while saving the ad.
    setIsSaving(true);

    const file = await fetch(currentEdit.src).then((r) => r.blob());
    const formData = new FormData();

    formData.append("file", file);
    formData.append("type", currentEdit.type);
    formData.append("link", currentEdit.link);

    if (currentEdit.type === "sub") {
      formData.append("index", currentEdit.index);
    }

    try {
      await fetch(`${API_URL}/updateAd`, {
        method: "POST",
        body: formData,
      });
    } finally {
      setIsSaving(false);
    }

    setShowModal(false);
    window.location.reload();
  };
  return (
    <Layout>
      <div className="ads-page">
        <div className="ads-container">
          {/* Heading */}
          <div className="ads-heading-row">
            <div>
              <h2 className="ads-title">Advertisements</h2>
              <p className="ads-subtitle">
                {1 + subAds.length} ad{" "}
                {1 + subAds.length === 1 ? "slot" : "slots"} configured
              </p>
            </div>
          </div>

          {/* Main Ad Section */}
          <div className="ads-card ads-card--main">
            <div className="ads-card-header">
              <h4>Main Ad</h4>
            </div>

            <div className="ads-card-body">
              <div className="ads-main-frame">
                <a href={mainAd.link} target="_blank" rel="noopener noreferrer">
                  <img
                    src={mainAd.src}
                    className="ads-main-img"
                    alt="Main ad"
                  />
                </a>

                <button
                  className="ads-btn ads-btn--edit"
                  onClick={() =>
                    handleEdit("main", null, mainAd.src, "", mainAd.link)
                  }
                >
                  Edit
                </button>
              </div>
            </div>
          </div>

          {/* Sub Ads Section */}
          <div className="ads-card">
            <div className="ads-card-header">
              <h4>Sub Ads</h4>
            </div>

            <div className="ads-card-body">
              <div className="ads-grid">
                {subAds.map((ad, index) => (
                  <div key={index} className="ads-tile">
                    <button
                      className="ads-btn ads-btn--edit ads-btn--sm"
                      onClick={() =>
                        handleEdit("sub", index, ad.src, ad.title, ad.link)
                      }
                    >
                      Edit
                    </button>

                    <a
                      href={ad.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="ads-tile-img-link"
                    >
                      <img
                        src={ad.src}
                        alt={ad.title}
                        className="ads-tile-img"
                      />
                    </a>

                    <span className="ads-tile-title">{ad.title}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Edit Modal */}
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          className="ads-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Edit {currentEdit.type === "main" ? "Main Ad" : "Sub Ad"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Select Image</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handleImageSelect}
                className="ads-input"
              />
              {currentEdit.src && (
                <img
                  src={currentEdit.src}
                  alt="Preview"
                  className="ads-preview-img"
                />
              )}
            </Form.Group>

            {currentEdit.type === "sub" && (
              <Form.Group className="mb-3">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  value={currentEdit.title}
                  onChange={(e) =>
                    setCurrentEdit({ ...currentEdit, title: e.target.value })
                  }
                  className="ads-input"
                />
              </Form.Group>
            )}

            <Form.Group>
              <Form.Label>Ad Link</Form.Label>
              <Form.Control
                type="text"
                value={currentEdit.link}
                onChange={(e) =>
                  setCurrentEdit({ ...currentEdit, link: e.target.value })
                }
                className="ads-input"
              />
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <button
              className="ads-btn ads-btn--ghost"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </button>
            <button
              className="ads-btn ads-btn--solid"
              onClick={handleSave}
              disabled={isSaving}
            >
              {isSaving ? "Saving..." : "Save"}
            </button>
          </Modal.Footer>
        </Modal>
      </div>

      <style>{`
        .ads-page {
            min-height: 100vh;
            background: #F7F8F6;
            font-family: 'Inter', sans-serif;
        }

        .ads-container {
            max-width: 1180px;
            width: 100%;
            margin: 0 auto;
            padding: 32px 24px;
        }

        .ads-heading-row {
            margin-bottom: 22px;
        }

        .ads-title {
            font-weight: 700;
            font-size: 24px;
            color: #1C2420;
            margin: 0;
        }

        .ads-subtitle {
            font-size: 13.5px;
            color: #8B978F;
            margin: 4px 0 0;
        }

        .ads-card {
            background: #fff;
            border-radius: 16px;
            border: 1px solid #EDEFEA;
            box-shadow: 0 1px 2px rgba(16, 24, 20, 0.03);
            overflow: hidden;
            margin-bottom: 28px;
        }

        .ads-card-header {
            padding: 16px 24px;
            background: rgba(245, 120, 12, 0.06);
            border-bottom: 1px solid #F7E2CC;
        }

        .ads-card-header h4 {
            font-weight: 700;
            font-size: 15px;
            color: #C7620A;
            margin: 0;
            text-transform: uppercase;
            letter-spacing: 0.04em;
        }

        .ads-card-body {
            padding: 24px;
        }

        .ads-main-frame {
            position: relative;
            text-align: center;
            background: #FAFAF8;
            border: 1px solid #F0F1EE;
            border-radius: 12px;
            padding: 16px;
        }

        .ads-main-img {
            max-height: 460px;
            max-width: 100%;
            object-fit: contain;
            border-radius: 10px;
        }

        .ads-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
            gap: 18px;
        }

        .ads-tile {
            position: relative;
            background: #FAFAF8;
            border: 1px solid #F0F1EE;
            border-radius: 12px;
            padding: 16px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 10px;
            text-align: center;
        }

        .ads-tile-img-link {
            display: block;
            width: 100%;
        }

        .ads-tile-img {
            width: 100%;
            max-height: 150px;
            object-fit: contain;
            border-radius: 8px;
        }

        .ads-tile-title {
            font-weight: 600;
            font-size: 13.5px;
            color: #C7620A;
        }

        .ads-btn {
            font-size: 13px;
            font-weight: 600;
            padding: 7px 14px;
            border-radius: 8px;
            border: 1.5px solid transparent;
            cursor: pointer;
            transition: all 0.15s ease;
            white-space: nowrap;
        }

        .ads-btn--sm {
            padding: 5px 11px;
            font-size: 12px;
        }

        .ads-btn--edit {
            position: absolute;
            top: 12px;
            right: 12px;
            background: #fff;
            color: #C7620A;
            border-color: #F5780C;
            box-shadow: 0 1px 3px rgba(16, 24, 20, 0.08);
            z-index: 2;
        }
        .ads-btn--edit:hover {
            background: #F5780C;
            color: #fff;
        }

        .ads-btn--solid {
            background: #F5780C;
            color: #fff;
        }
        .ads-btn--solid:hover { background: #D9690A; }

        .ads-btn--ghost {
            background: transparent;
            color: #5C6862;
            border-color: #E2E5E0;
        }
        .ads-btn--ghost:hover { background: #F5F6F4; }

        .ads-input {
            border-radius: 8px !important;
            border: 1.5px solid #E2E5E0 !important;
        }
        .ads-input:focus {
            border-color: #F5780C !important;
            box-shadow: 0 0 0 3px rgba(245, 120, 12, 0.12) !important;
        }

        .ads-preview-img {
            display: block;
            max-width: 100%;
            max-height: 200px;
            object-fit: contain;
            border-radius: 8px;
            margin-top: 12px;
            border: 1px solid #EDEFEA;
        }

        .ads-modal .modal-content {
            border-radius: 16px;
            border: none;
        }

        .ads-modal .modal-header {
            background: rgba(245, 120, 12, 0.06);
            border-bottom: 1px solid #F7E2CC;
        }

        .ads-modal .modal-title {
            color: #C7620A;
            font-weight: 700;
            font-size: 18px;
        }

        .ads-modal .modal-footer {
            border-top: 1px solid #F2F3F0;
        }

        .ads-modal label {
            font-weight: 600;
            font-size: 13.5px;
            color: #333B36;
        }
    `}</style>
    </Layout>
  );
};

export default AdsComponent;
